/*eslint-disable */
import Browser from "./Browser";
import * as THREE from "three";
import CSS3DRenderer, { CSS3DObject } from "./CSS3DRenderer";
var MAX_FOV = 100,
  MIN_FOV = 8,
  delta,
  noop = function () {};
import { helper, events } from "./eventHandler";
import { DeviceOrientationControls } from "three-controls-deviceorientation";
const EventEmitter = require("eventemitter3");

//polyfill for IE < 9
if (!Object.create) {
  Object.create = (function () {
    function F() {}

    return function (o) {
      if (arguments.length != 1) {
        throw new Error(
          "Object.create implementation only accepts one parameter."
        );
      }
      F.prototype = o;
      return new F();
    };
  })();
}

function fireEvent(eventName, player) {
  if (eventName == "viewReady" && player.viewReadyFired) {
    return;
  }

  var event = document.createEvent("HTMLEvents");
  event.initEvent(eventName, true, true);

  event.eventName = eventName;

  player.elem.dispatchEvent(event);
  if (eventName == "viewReady") {
    helper.trigger(events.aPanoPlayersViewReady);
    player.viewReadyFired = true;
  }
  player.eventEmitter.emit(eventName, null);
}

function originCacheBuster(path) {
  //adds the protocol to protect against different origins being sent
  //and a daily timestamp in case it gets corrupted (ie a request with no origin is sent)
  return (
    path +
    "?" +
    encodeURIComponent(window.location.protocol.replace(":", "")) +
    new Date().getUTCDay()
  );
}

/**
 * Draws a rounded rectangle using the current state of the canvas.
 * If you omit the last three params, it will draw a rectangle
 * outline with a 5 pixel border radius
 * @param {CanvasRenderingContext2D} ctx
 * @param {Number} x The top left x coordinate
 * @param {Number} y The top left y coordinate
 * @param {Number} width The width of the rectangle
 * @param {Number} height The height of the rectangle
 * @param {Number} [radius = 5] The corner radius; It can also be an object
 *                 to specify different radii for corners
 * @param {Number} [radius.tl = 0] Top left
 * @param {Number} [radius.tr = 0] Top right
 * @param {Number} [radius.br = 0] Bottom right
 * @param {Number} [radius.bl = 0] Bottom left
 * @param {Boolean} [fill = false] Whether to fill the rectangle.
 * @param {Boolean} [stroke = true] Whether to stroke the rectangle.
 */
CanvasRenderingContext2D.prototype.roundRect = function (
  x,
  y,
  width,
  height,
  radius
) {
  if (!radius) {
    radius = Math.min(width, height) / 2;
  }
  if (typeof radius === "number") {
    radius = {
      tl: radius,
      tr: radius,
      bl: radius,
      br: radius,
    };
  }
  this.beginPath();
  //upper right
  this.moveTo(x + width - radius.tr, y);
  this.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  //bottom right
  this.lineTo(x + width, y + height - radius.br);
  this.quadraticCurveTo(
    x + width,
    y + height,
    x + width - radius.br,
    y + height
  );
  //bottom left
  this.lineTo(x + radius.bl, y + height);
  this.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  //upper left
  this.lineTo(x, y + radius.tl);
  this.quadraticCurveTo(x, y, x + radius.tl, y);
  this.closePath();
};

var EventHandler = function (self) {
  this.events = {};
  this.self = self;
};

window.EventHandler = EventHandler;

EventHandler.prototype.add = function (name, call) {
  var list = this.events[name] || [];
  list.push(call);
  this.events[name] = list;
};

EventHandler.prototype.remove = function (name, call) {
  var list = this.events[name] || [];
  if (call) {
    var index = list.indexOf(call);
    if (index != -1) {
      list.splice(index, 1);
    }
  } else {
    list = [];
  }
  this.events[name] = list;
};

EventHandler.prototype.call = function (name, args) {
  var list = this.events[name] || [],
    ret;
  for (var i = 0; i < list.length; i++) {
    ret = list[i].apply(this.self, args);
  }
  return ret;
};

THREE.Scene.prototype.call = THREE.Object3D.prototype.call = function (
  name,
  args
) {
  return this.event ? this.event.call(name, args) : null;
};

THREE.Scene.prototype.addEvent = THREE.Object3D.prototype.addEvent = function (
  name,
  callback
) {
  this.event = this.event || new EventHandler(this);
  this.event.add(name, callback);
};

THREE.Scene.prototype.removeEvent = THREE.Object3D.prototype.removeEvent = function (
  name,
  callback
) {
  this.event = this.event || new EventHandler(this);
  this.event.remove(name, callback);
};

THREE.Scene.prototype.draw = function (d) {
  this.call("draw", [d]);
};

// Used to calculate intersection when transmitting click events to PositonalMedia meshes for custom ui play/pause toggling
var raycaster = new THREE.Raycaster();
THREE.Scene.prototype.getIntersection = function (name, camera, mouse) {
  var toclick;
  if (mouse) {
    // update the picking ray with the camera and mouse position
    raycaster.setFromCamera(
      new THREE.Vector2(mouse.x, mouse.y),
      camera.getCamera()
    );
    // calculate objects intersecting the picking ray
    this.traverse(function (child) {
      var intersection = raycaster.intersectObject(child)[0];
      if (intersection) {
        if (name != "click") {
          child.call(name, [intersection]);
        } else {
          toclick = [child, intersection];
        }
      }
      toclick = child.call("intersection", [name]) || toclick;
    });
  }
  return toclick;
};

/*                                                                                                                                                                           
PPPPPPPPPPPPPPPPP                                                     PPPPPPPPPPPPPPPPP   lllllll                                                                              
P::::::::::::::::P                                                    P::::::::::::::::P  l:::::l                                                                              
P::::::PPPPPP:::::P                                                   P::::::PPPPPP:::::P l:::::l                                                                              
PP:::::P     P:::::P                                                  PP:::::P     P:::::Pl:::::l                                                                              
P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo     P::::P     P:::::P l::::l   aaaaaaaaaaaaayyyyyyy           yyyyyyy eeeeeeeeeeee    rrrrr   rrrrrrrrr   
P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo   P::::P     P:::::P l::::l   a::::::::::::ay:::::y         y:::::yee::::::::::::ee  r::::rrr:::::::::r  
P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o  P::::PPPPPP:::::P  l::::l   aaaaaaaaa:::::ay:::::y       y:::::ye::::::eeeee:::::eer:::::::::::::::::r 
P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o  P:::::::::::::PP   l::::l            a::::a y:::::y     y:::::ye::::::e     e:::::err::::::rrrrr::::::r
P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o  P::::PPPPPPPPP     l::::l     aaaaaaa:::::a  y:::::y   y:::::y e:::::::eeeee::::::e r:::::r     r:::::r
P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o  P::::P             l::::l   aa::::::::::::a   y:::::y y:::::y  e:::::::::::::::::e  r:::::r     rrrrrrr
P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o  P::::P             l::::l  a::::aaaa::::::a    y:::::y:::::y   e::::::eeeeeeeeeee   r:::::r            
P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o  P::::P             l::::l a::::a    a:::::a     y:::::::::y    e:::::::e            r:::::r            
PP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::oPP::::::PP          l::::::la::::a    a:::::a      y:::::::y     e::::::::e           r:::::r            
P::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::oP::::::::P          l::::::la:::::aaaa::::::a       y:::::y       e::::::::eeeeeeee   r:::::r            
P::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo P::::::::P          l::::::l a::::::::::aa:::a     y:::::y         ee:::::::::::::e   r:::::r            
PPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   PPPPPPPPPP          llllllll  aaaaaaaaaa  aaaa    y:::::y            eeeeeeeeeeeeee   rrrrrrr            
                                                                                                                     y:::::y                                                 
                                                                                                                    y:::::y                                                  
                                                                                                                   y:::::y                                                   
                                                                                                                  y:::::y                                                    
                                                                                                                 yyyyyyy                                                     
                                                                                                                                                                      
*/
var PanoPlayer =
  window.PanoPlayer ||
  function () {
    //setup vars

    //zooms: the total width of the resultant image
    //height will be width/2. ofr cube width = 4*tileSize
    this.zoomLevels = [512, 1024, 2048, 3072, 4096, 6144];
    this.defaults = {
      rotation: 0,
      showRotate: true,
      showFullscreen: true,
      autoRotate: false,
      autoRotateSpeed: 0.3,
      maxAngle: { h: 360, v: 89.9 },
      minAngle: { h: -360, v: -90 },
      startLon: 180,
      startLat: 0,
      startFov: null,
      hasEasy: false,
      width: null,
      height: null,
      title: null,
      showHint: true,
      hintTimeout: 5000,
      hintPosition: {
        top: "40%",
        left: "50%",
      },
      viewPercent: 0.35,
      businessCard: null,
      depthMarkers: null,
      localMode: null,
      accelerometerControls: false,
      clearSelectorHTML: false,
    };

    //brower - pano type map
    this.defaultTypeMap = [
      PanoPlayer.types.EASY,
      PanoPlayer.types.EQUIRECTANGULAR,
    ];

    //browsers checked in order so more specific first
    this.typeMap = {
      mobile: this.defaultTypeMap,
      chrome: this.defaultTypeMap,
      firefox: this.defaultTypeMap,
      safari: this.defaultTypeMap,
      ie11: [
        PanoPlayer.types.EASY,
        PanoPlayer.types.WEBGL,
        PanoPlayer.types.FLASH,
        PanoPlayer.types.CANVAS,
      ],
      ie: [PanoPlayer.types.FLASH, PanoPlayer.types.CANVAS],
    };

    this.buttonSize = 40;

    this.viewReadyFired = false;

    this.creationDimensions = {
      height: 0,
      width: 0,
    };

    this.eventEmitter = undefined;

    this.isMobile = Browser.is("mobile");

    return PanoPlayer.prototype.init.apply(this, arguments);
  };

PanoPlayer.types = {
  EASY: "easy",
  WEBGL: "webgl",
  CSS3D: "css3d",
  CANVAS: "canvas",
  FLASH: "flash",
  EQUIRECTANGULAR: "equirectangular",
};

PanoPlayer.getTileUrl = function (panoPath, type, size, coord) {
  return Panorama.getTileUrl(panoPath, type, size, coord);
};

PanoPlayer.fn = PanoPlayer.prototype = {
  init: function (options) {
    var type;

    //clone the defaults object so its values arent overwritten
    this.options = Object.create(this.defaults);
    for (var name in options) {
      if (options[name] !== null && typeof options[name] != "undefined")
        this.options[name] = options[name];
    }

    if (!this.options.localMode) {
      if (options.path != undefined) {
        this.panoId = this.parsePath(options.path);
      } else {
        this.panoId = this.options.panoId;
        this.basePath = this.options.basePath;
      }

      if (this.panoId === undefined || this.basePath === undefined) {
        throw {
          name: "InvalidUsage",
          message:
            "Cannot create a panorama without a pano ID and basePath set",
        };
      }

      //ensure basepath has closing slash
      if (this.basePath[this.basePath.length - 1] != "/") {
        this.basePath += "/";
      }
    }
    this.eventEmitter = this.options.eventEmitter || new EventEmitter();

    this.elem =
      typeof this.options.selector === "string"
        ? document.querySelectorAll("#" + this.options.selector, document)[0]
        : this.options.selector;

    if (!this.elem) {
      throw {
        name: "InvalidUsage",
        message: "An existing element must be used to embed the panorama",
      };
    }

    this.autoRotate = this.options.autoRotate;
    this.autoRotateSpeed = this.options.autoRotateSpeed;
    this.showHint = this.options.showHint;
    this.fullscreen = false;

    this.viewerWidth =
      this.options.width || this.elem.clientWidth || window.innerWidth;
    this.viewerHeight =
      this.options.height || this.elem.clientHeight || window.innerHeight;

    if (+this.viewerWidth != this.viewerWidth) {
      if (this.viewerWidth[this.viewerWidth.length - 1] != "%") {
        throw {
          name: "InvalidUsage",
          message: "Invalid string passed for width",
        };
      }

      var Wpercent =
        this.viewerWidth.substring(0, this.viewerWidth.length - 1) / 100;
      this.viewerWidth =
        Wpercent * (this.elem.clientWidth || window.innerWidth);
    }

    if (+this.viewerHeight != this.viewerHeight) {
      if (this.viewerHeight[this.viewerHeight.length - 1] != "%") {
        throw {
          name: "InvalidUsage",
          message: "Invalid string passed for height",
        };
      }

      var Hpercent =
        this.viewerHeight.substring(0, this.viewerHeight.length - 1) / 100;
      this.viewerHeight =
        Hpercent * (this.elem.clientHeight || window.innerHeight);
      this.creationDimensions.width = this.viewerWidth;
      this.creationDimensions.height = this.viewerHeight;
    }

    this.autoResize = this.options.autoResize || false;
    this.fullWindow =
      this.viewerWidth == window.innerWidth &&
      this.viewerHeight == window.innerHeight;

    this.type = options.type || this.getType();

    this.zoom = this.calculateZoom(
      PanoPlayer.panoramas[this.type].allowedZooms
    );
    this.panorama = new PanoPlayer.panoramas[this.type](this);

    return this;
  },

  parsePath: function (path) {
    this.path = path;
    var pos = this.path.lastIndexOf("/");
    // Remove any slashes at the end of the URL
    if (pos == this.path.length - 1) {
      this.basePath = this.path.substring(0, pos);
    } else {
      this.basePath = this.path;
    }
    pos = this.basePath.lastIndexOf("/");
    var panoId = this.basePath.substring(pos + 1);
    this.basePath = this.basePath.substring(0, pos);
    return panoId;
  },
  /**
   * forceZoomOut()
   *
   * Running this function test, whether the current size of the pano player is
   * larger then the size of the pano player on its createion.
   * If this is true it will forcible zoom out the player, since this case cause the
   * panorama to be zoomed in very closes, and looks bad.
   * Other wise it does nothing
   *
   * @return PanoPlayer, instace of
   */
  forceZoomOut: function () {
    var newWidth = this.elem.clientWidth || window.innerWidth,
      newHeight = this.elem.clientHeight || window.innerHeight;

    if (
      newWidth > this.creationDimensions.width ||
      newHeight > this.creationDimensions.height
    ) {
      this.panorama.camera.zoom(-120);
    }
    return this;
  },

  embed: function () {
    var _this = this;

    if (this.loading) {
      setTimeout(this.embed.bind(this), 100);
      return this;
    }

    //Clear out target HTML
    if (this.options.clearSelectorHTML) this.elem.innerHTML = "";
    this.elem.appendChild(this.panorama.element);

    this.panorama.setSize(this.viewerWidth, this.viewerHeight);
    if (this.fullWindow || this.autoResize) {
      window.addEventListener("resize", this, false);
    }

    this.panorama.embed();

    return this;
  },

  on: function (name, cb) {
    this.eventEmitter.on(name, cb);
    return this;
  },

  off: function (name, cb) {
    if (cb) {
      this.eventEmitter.off(name, cb);
    } else {
      this.eventEmitter.removeEvent(name);
    }
    return this;
  },

  destroy: function (options) {
    var causedBySwap = typeof options !== "undefined" && options.causedBySwap;
    window.removeEventListener("resize", this);
    document.removeEventListener("fullscreenchange", this);
    document.removeEventListener("mozfullscreenchange", this);
    document.removeEventListener("webkitfullscreenchange", this);

    this.eventEmitter.emit("destroy", null);
    this.eventEmitter.removeAllListeners();

    this.panorama && this.panorama.destroy();
    delete this.panorama;
  },

  handleEvent: function (event) {
    if (event.type == "resize") {
      var width = window.innerWidth;
      var height = window.innerHeight;
      if (!this.fullWindow && !this.fullscreen) {
        width = this.elem.parentElement.clientWidth
        height = this.elem.parentElement.clientHeight
      }
      if (width > 0 && height > 0) this.setSize(width, height);
    }

    if (
      event.type.indexOf("fullscreenchange") != -1 &&
      ((document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen))
    ) {
      this.setFullscreen(false);
    }
  },

  /**
   * This will update the panorama with a new panorama
   * @param {object|int} pano The ID of the new panorama or the data object containing its info
   */

  setSource: function (pano) {
    var panoId;

    if (typeof pano == "object") {
      if (!pano.id && pano.path) {
        panoId = this.parsePath(pano.path);
      } else {
        panoId = pano.id;
      }

      if (this.panorama.camera) {
        this.panorama.camera.getCamera().fov =
          typeof pano.start_fov != "undefined"
            ? pano.start_fov
            : this.calculateStartFov(this.defaults.viewPercent);
        this.panorama.camera.lon = Number(
          typeof pano.start_lon != "undefined"
            ? pano.start_lon
            : this.defaults.startLon
        );
        this.panorama.camera.lat = Number(
          typeof pano.start_lat != "undefined"
            ? pano.start_lat
            : this.defaults.startLat
        );
        this.panorama.camera.refreshView();
        this.panorama.camera.refreshZoom();
      }
    } else {
      panoId = pano;
    }

    this.viewReadyFired = false;

    if (this.panoId != panoId) {
      this.panoId = panoId;
      this.panorama.regenerateTextures();
    }
  },

  setSize: function (width, height) {
    this.viewerWidth = width;
    this.viewerHeight = height;
    this.panorama.setSize(width, height);

    var oldZoom = this.zoom;
    this.zoom = this.calculateZoom(
      PanoPlayer.panoramas[this.type].allowedZooms
    );

    if (oldZoom < this.zoom) {
      this.panorama.regenerateTextures();
    }
  },

  calculateZoom: function (allowedZooms) {
    var zoom,
      multiplyer = this.isMobile ? 1.8 : 1.25,
      fov = this.getFov() || this.getStartFov() || 100,
      vfovRad = (fov * Math.PI) / 180,
      hfovRad =
        2 *
        Math.atan(
          (Math.tan(vfovRad / 2) * this.viewerWidth) / this.viewerHeight
        ),
      hfov = Math.ceil((hfovRad * 180) / Math.PI),
      minPanoWidth = (this.viewerWidth / hfov) * 360 * multiplyer;

    for (var z in allowedZooms) {
      zoom = allowedZooms[z];
      if (minPanoWidth < this.zoomLevels[zoom]) break;
    }

    if (this.isMobile && zoom > 4) {
      zoom = 4;
    }

    return zoom;
  },

  getType: function () {
    if (this.options.localMode) {
      return "equi";
    }

    var types = this.defaultTypeMap,
      type;
    for (var browser in this.typeMap) {
      if (Browser.is(browser)) {
        types = this.typeMap[browser];
        break;
      }
    }

    for (type in types) {
      //See if easy is an option
      if (
        types[type] == PanoPlayer.types.EASY 
        // && this.options.hasEasy != true
      ) {
        continue;
      }

      if (Browser.can(types[type])) {
        break;
      }
    }

    return types[type];
  },

  getPanoWidth: function () {
    return this.zoomLevels[this.zoom];
  },
  getPanoHeight: function () {
    return this.getPanoWidth() / 2;
  },

  getStartLon: function () {
    return +this.options.startLon;
  },
  getStartLat: function () {
    return +this.options.startLat;
  },
  getLat: function () {
    if (
      typeof this.panorama !== "undefined" &&
      typeof this.panorama.camera !== "undefined"
    ) {
      return this.panorama.camera.lat;
    }
    return null;
  },
  getLon: function () {
    if (
      typeof this.panorama !== "undefined" &&
      typeof this.panorama.camera !== "undefined"
    ) {
      return this.panorama.camera.lon;
    }
    return null;
  },
  getFov: function () {
    if (
      typeof this.panorama !== "undefined" &&
      typeof this.panorama.camera !== "undefined"
    ) {
      return this.panorama.camera._camera.fov;
    }
    return null;
  },

  /**
   * rotate the panorama to the desired position. The function can set angle immediately or incremental
   * based on a time limit or a speed
   *
   * @param position       {lat, lon, fov}
   * @param optionss       {speed (degrees per second), duration (milliseconds), callback}
   *
   * Set either speed or duration.
   */
  setPosition: function (position, options) {
    if (
      typeof this.panorama !== "undefined" &&
      typeof this.panorama.camera !== "undefined"
    ) {
      this.panorama.camera.setAbsolutePosition(position, options);
    }
  },
  getStartFov: function () {
    var unbounded =
      this.options.startFov || this.calculateStartFov(this.options.viewPercent);

    return Math.max(Math.min(unbounded, MAX_FOV), MIN_FOV);
  },

  getCameraOptions: function () {
    return {
      maxAngle: this.options.maxAngle,
      minAngle: this.options.minAngle,
      fov: this.getStartFov(),
      maxFov: MAX_FOV,
      minFov: MIN_FOV,
      startLon: this.getStartLon(),
      startLat: this.getStartLat(),
      height: this.viewerHeight,
      width: this.viewerWidth,
      autoRotate: this.autoRotate,
      autoRotateSpeed: this.autoRotateSpeed,
      accelerometerControls: this.options.accelerometerControls,
    };
  },

  /**
   * Calculates the starting field-of-view from a percentage of the
   * panorama that should be visible on first load
   *
   * This option is passed in to allow calculating of starting FOV
   * independent of the options passed in
   *
   * @param {Number} viewPercent A number such 0 < viewPercent <= 1
   *                             representing the percentage of the view
   */
  calculateStartFov: function (viewPercent) {
    var views =
        1 / viewPercent + (this.viewerWidth > this.viewerHeight ? 0 : 1.0), //for screens with an odd orientation show extra view
      distance = this.viewerWidth;

    return (
      2 *
      Math.atan(
        (this.viewerHeight / distance) * Math.tan((2 * Math.PI) / (views * 2))
      ) *
      (180 / Math.PI)
    );
  },

  setLoading: function (loading) {
    this.loading = loading;
  },

  setFullscreen: function (on) {
    if (on) {
      var fse =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;

      if (fse) {
        return;
      }

      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        this.elem.webkitRequestFullscreen();
      }

      this.oldWidth = this.viewerWidth;
      this.oldHeight = this.viewerHeight;
      this.setSize(screen.width, screen.height);
      this.fullscreen = on;
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
      this.setSize(this.oldWidth, this.oldHeight);
      this.fullscreen = on;
    }
  },

  setAutoRotate: function (on, autoRotateSpeed) {
    if (
      typeof this.panorama !== "undefined" &&
      typeof this.panorama.camera !== "undefined"
    ) {
      this.autoRotate = !this.panorama.camera.isDisabled() && on;
      if (on) {
        this.autoRotateSpeed = autoRotateSpeed;
      }
      this.panorama.setAutoRotate(this.autoRotate, autoRotateSpeed);
    }
  },

  enableAccelerometerControls: function (enable) {
    this.panorama.camera.enableAccelerometerControls(enable);
  },

  requestUpdate: function () {
    if (typeof this.panorama !== "undefined") {
      this.panorama.needsRefresh = true;
    }
  },
};

/*                                                                                                           
      CCCCCCCCCCCCC                                                                                                  
   CCC::::::::::::C                                                                                                  
 CC:::::::::::::::C                                                                                                  
C:::::CCCCCCCC::::C                                                                                                  
C:::::C       CCCCCC  aaaaaaaaaaaaa      mmmmmmm    mmmmmmm       eeeeeeeeeeee    rrrrr   rrrrrrrrr   aaaaaaaaaaaaa   
C:::::C                a::::::::::::a   mm:::::::m  m:::::::mm   ee::::::::::::ee  r::::rrr:::::::::r  a::::::::::::a  
C:::::C                aaaaaaaaa:::::a m::::::::::mm::::::::::m e::::::eeeee:::::eer:::::::::::::::::r aaaaaaaaa:::::a 
C:::::C                         a::::a m::::::::::::::::::::::me::::::e     e:::::err::::::rrrrr::::::r         a::::a 
C:::::C                  aaaaaaa:::::a m:::::mmm::::::mmm:::::me:::::::eeeee::::::e r:::::r     r:::::r  aaaaaaa:::::a 
C:::::C                aa::::::::::::a m::::m   m::::m   m::::me:::::::::::::::::e  r:::::r     rrrrrrraa::::::::::::a 
C:::::C               a::::aaaa::::::a m::::m   m::::m   m::::me::::::eeeeeeeeeee   r:::::r           a::::aaaa::::::a 
C:::::C       CCCCCCa::::a    a:::::a m::::m   m::::m   m::::me:::::::e            r:::::r          a::::a    a:::::a 
C:::::CCCCCCCC::::Ca::::a    a:::::a m::::m   m::::m   m::::me::::::::e           r:::::r          a::::a    a:::::a 
 CC:::::::::::::::Ca:::::aaaa::::::a m::::m   m::::m   m::::m e::::::::eeeeeeee   r:::::r          a:::::aaaa::::::a 
   CCC::::::::::::C a::::::::::aa:::am::::m   m::::m   m::::m  ee:::::::::::::e   r:::::r           a::::::::::aa:::a
      CCCCCCCCCCCCC  aaaaaaaaaa  aaaammmmmm   mmmmmm   mmmmmm    eeeeeeeeeeeeee   rrrrrrr            aaaaaaaaaa  aaaa
*/

var MIN_NEAR_VIEW = 0.001;
var MAX_FAR_VIEW = 100000;

//support objects
function Camera(options, panorama) {
  var scope = this;
  this.isMouseMoving = false;
  this.disabled = false;
  this.startX = 0;
  this.startY = 0;
  this.lonVelocity = 0;
  this.latVelocity = 0;
  this.autoRotateSpeed = options.autoRotateSpeed || 0.3;

  // Variables for tracking rotation to a specific position
  this.autoRotate = options.autoRotate;
  this.rotationObject = {};

  // save the last lat and long reading so we can calculate deltas later
  this.lastLat = 0;
  this.lastLon = 0;

  // objects used to get the orientation
  this.deviceOrientatioCamera = null;
  this.deviceOrientationControls = null;

  this.panorama = panorama;

  this.clock = new THREE.Clock();
  this._camera = new THREE.PerspectiveCamera(
    options.fov,
    options.width / options.height,
    MIN_NEAR_VIEW,
    MAX_FAR_VIEW
  );
  this._camera.target = new THREE.Vector3();

  //setup raycaster objects
  this.pointerVector = new THREE.Vector3();
  this.raycaster = new THREE.Raycaster();

  this.lon = options.startLon;
  this.lat = options.startLat;

  this.latDiff = this.lonDiff = 0;

  this.maxLat = options.maxAngle.v;
  this.minLat = options.minAngle.v;

  this.maxLon = options.maxAngle.h;
  this.minLon = options.minAngle.h;

  this.minFov = options.minFov;
  this.maxFov = options.maxFov;

  this.updateMatrix(options.width, options.height);

  this.lonDeceleration = 0.85;
  this.latDeceleration = 0.7;

  this.refreshView();

  this.accelerometerControls = options.accelerometerControls;
  if (this.accelerometerControls) {
    this.deviceOrientatioCamera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    this.deviceOrientationControls = new DeviceOrientationControls(
      this.deviceOrientatioCamera
    );

    this.onDeviceMotion = this.onDeviceMotion.bind(this);
    this.deviceIsInMotion = false;

    window.addEventListener("devicemotion", this.onDeviceMotion);
  }

  return this;
}

Camera.prototype = {
  setDisabled: function (disabled) {
    this.setAutoRotate(false);
    this.disabled = disabled;
  },
  isDisabled: function () {
    return this.disabled;
  },
  refreshView: function () {
    var delta = this.clock.getDelta();

    if (this.isRotating) {
      var timediff =
        this.rotationObject.duration +
        this.rotationObject.startTime -
        new Date().getTime();
      if (timediff <= 0) {
        this.isRotating = false;
        this.lat = this.rotationObject.targetLat;
        this.lon = this.rotationObject.targetLon;
        if (this.rotationObject.callback) {
          this.rotationObject.callback();
        }
        this.rotationObject = {};
      } else {
        var totalChunks =
          (new Date().getTime() - this.rotationObject.startTime) /
          this.rotationObject.duration; //seconds ellapsed

        this.lat =
          (this.rotationObject.targetLat - this.rotationObject.fromLat) *
            totalChunks +
          this.rotationObject.fromLat;
        this.lon =
          (this.rotationObject.targetLon - this.rotationObject.fromLon) *
            totalChunks +
          this.rotationObject.fromLon;
      }
    }
    if (this.isMouseMoving) {
      this.latVelocity = this.latDiff / delta;
      this.lonVelocity = this.lonDiff / delta;
    } else if (this.lonVelocity || this.latVelocity) {
      this.lon += this.lonVelocity * delta;
      this.lat += this.latVelocity * delta;

      this.lonVelocity =
        Math[this.lonVelocity > 0 ? "floor" : "ceil"](
          this.lonVelocity * this.lonDeceleration * 100
        ) / 100;
      this.latVelocity =
        Math[this.latVelocity > 0 ? "floor" : "ceil"](
          this.latVelocity * this.latDeceleration * 100
        ) / 100;
    }

    if (!isFinite(this.latVelocity) || !isFinite(this.lonVelocity)) {
      this.latVelocity = 0;
      this.lonVelocity = 0;
    }

    if (this.autoRotate) {
      this.lon += this.autoRotateSpeed;
    }

    if (
      this.accelerometerControls &&
      this.deviceOrientatioCamera &&
      !this.isMouseMoving
    ) {
      // update the camera's orientation
      this.deviceOrientationControls.update();

      // calculate the deltas for the orientation
      var deltas = this.calculateOrientationDeltas();

      var resetOrientationDeltas = this.isOrientationDeltasReset();

      if (resetOrientationDeltas) {
        this.setResetOrientationDeltas(false);

        // calculateOrientationDeltas still needs to be called as it manages lastLat and lastLon state
        deltas = { lat: 0, lon: 0 };
      }

      // add them to our lat / lon
      this.latDiff += isNaN(deltas.lat) ? 0 : deltas.lat;
      this.lonDiff += isNaN(deltas.lon) ? 0 : deltas.lon;
    } // end if acceleromter controls are enabled

    this.lat += this.latDiff;
    this.lon += this.lonDiff;

    this.latDiff = this.lonDiff = 0;

    this.lat = Math.max(this.minLat, Math.min(this.maxLat, this.lat));
    this.lon = Math.max(this.minLon, Math.min(this.maxLon, this.lon % 360));

    //dont let lon be negative
    if (this.lon < 0) {
      this.lon = 360 + this.lon;
    }

    var phi = ((90 - this.lat) * Math.PI) / 180; // phi sets lateral motion (converted to radians)
    var theta = (this.lon * Math.PI) / 180; // theta sets horizontal motion (converted to radians)

    /* Javascript Math functions for circles only take radians */
    this._camera.target.x = Math.sin(phi) * Math.cos(theta);
    this._camera.target.y = Math.cos(phi);
    this._camera.target.z = Math.sin(phi) * Math.sin(theta);

    this._camera.lookAt(this._camera.target);

    this.dirtyZoom = false;

    this.refreshCallback({
      lon: this.lon,
      lat: this.lat,
      fov: this._camera.fov,
    });
  },

  setResetOrientationDeltas: function (reset) {
    this.resetOrientationDeltas = reset;
  },

  isOrientationDeltasReset: function () {
    return this.resetOrientationDeltas;
  },

  calculateOrientationDeltas: function () {
    // lattitude (vertical) and longitude (yaw) are handled a bit differently.
    // lattitude doesn't need to wrap at the top or bottom, so we can just use the interpolaed values directly,
    // while longitude needs to wrap from 0 to 360 or 360 to 0.

    // lattitude

    // interpolate the lattitude (pitch) from the raw value which is between -PI/2 to PI/2.
    var lat =
      ((this.deviceOrientatioCamera.rotation._x + Math.PI / 2) / Math.PI) *
        (this.maxLat - this.minLat) +
      this.minLat;

    // the deltalat, therefore is easily just the current lat minus the previous late:
    var deltaLat = lat - this.lastLat;

    // set for next time
    this.lastLat = lat;

    // longitude

    var totalLonRange = this.maxLon - this.minLon;

    // let's interpolate the value normally at first (from -PI to PI), but below we will need a bit of extra logic to handle when it wraps
    var lon =
      -(
        ((this.deviceOrientatioCamera.rotation._y + Math.PI) / (Math.PI * 4)) *
        totalLonRange
      ) + this.minLon;

    // calculate an initial delta:
    var deltaLon = lon - this.lastLon;

    // set for next time
    this.lastLon = lon;

    // if the delta is greater than 180 in either direction, it most likely wrapped (nobody can move that fast)
    // but we can't compare to 180; when need to compare to 180 in the PanoPlayers units, i.e.: half the total distance of longitude
    var pano180 = totalLonRange / 2;
    if (Math.abs(deltaLon) > pano180) {
      // if the jump is negative, we went from a high value to a low value - essentially jumping from ~360 to ~0
      // let's adjust the delta for that jump
      if (deltaLon < 0) {
        // new delta is the sum of two differences: from the old pos to the maximum, and from the minimum to the new pos:
        deltaLon = this.maxLon - this.lastLon + (lon - this.minLon);

        // otherwise, if the jump is positive, we wraped from around ~0 to ~360
      } else if (deltaLon > 0) {
        // new delta is the sum of two differences: from the old pos to the minimum, and from the maximum to the new pos:
        deltaLon = this.lastLon - this.minLon + (this.maxLon - lon);
      }

      // note: inside this if block, deltaLon could never be 0.
    } // end if large jump

    // return our deltas
    return {
      lat: deltaLat,
      lon: deltaLon,
    };
  },

  destroy: function () {
    if (this.deviceOrientationControls) {
      this.deviceOrientationControls.dispose();
      window.removeEventListener("devicemotion", this.onDeviceMotion);
    }
  },

  onDeviceMotion: function (event) {
    var rotationRate = event.rotationRate,
      alpha = rotationRate.alpha, //Z axis; that is, being twisted about a line perpendicular to the screen.
      beta = rotationRate.beta, //X axis; that is, front to back.
      gamma = rotationRate.gamma; //Y axis; that is, side to side.

    // If device rotation rate moved greater than 30 degrees let's emit devicemotionstart event
    if (
      !this.deviceIsInMotion &&
      Math.max(Math.abs(alpha), Math.abs(beta), Math.abs(gamma)) > 30
    ) {
      this.deviceIsInMotion = true;
      this.panorama.player.eventEmitter.emit("devicemotionstart", [event]);
    } else {
      if (this.deviceIsInMotion)
        this.panorama.player.eventEmitter.emit("devicemotionend", [event]);

      this.deviceIsInMotion = false;
    }
  },

  enableAccelerometerControls: function (enable) {
    this.accelerometerControls = enable;
  },

  hasDeviceControls: function () {
    return !!this.deviceOrientationControls;
  },

  resetDeviceOrientationAlphaAngle: function () {
    if (this.hasDeviceControls()) {
      var deviceControl = this.deviceOrientationControls;

      var alpha = deviceControl.alpha - deviceControl.alphaOffsetAngle;

      deviceControl.updateAlphaOffsetAngle(alpha * -1);
    }
  },

  refreshCallback: function () {},

  needsRefresh: function () {
    return (
      this.isRotating ||
      this.isMouseMoving ||
      +this.latVelocity ||
      +this.lonVelocity ||
      this.dirtyZoom ||
      this.autoRotate ||
      this.accelerometerControls ||
      this.latDiff ||
      this.lonDiff
    );
  },

  updateMatrix: function (width, height) {
    if (width != undefined && height != undefined) {
      this.viewerWidth = width;
      this.viewerHeight = height;

      //this hook allows us to swap out different tracking functions
      this.setPosition = this.setPositionExact;
    }

    this._camera.aspect = this.viewerWidth / this.viewerHeight;
    this._camera.updateProjectionMatrix();
  },

  zoom: function (wheelDelta) {
    this._camera.fov -= wheelDelta;
    this.refreshZoom();
  },

  refreshZoom: function () {
    this.dirtyZoom = true;
    this._camera.fov = Math.min(
      this.maxFov,
      Math.max(this.minFov, this._camera.fov)
    );
    this._camera.updateProjectionMatrix();
  },

  getCamera: function () {
    return this._camera;
  },

  setAutoRotate: function (onOff, autoRotateSpeed) {
    this.autoRotate = !this.isDisabled() && onOff;
    if (autoRotateSpeed) {
      this.autoRotateSpeed = autoRotateSpeed;
    }
  },

  setMouseMoving: function (moving) {
    this.isMouseMoving = moving;
  },

  setStart: function (x, y) {
    this.startPoint = this.getPointFromMouse(x, y);

    this.startX = x;
    this.startY = y;
    this.startTime = this.clock.getElapsedTime();
  },

  getPosition: function () {
    return {
      lat: this.lat,
      lon: this.lon,
      fov: this._camera.fov,
    };
  },

  /*
  this function returns the shortest distance coord from current to target
  this will prevent the camera from rotating more than 180 degrees
   */
  getShortestLatLon: function (lat, lon) {
    var f = function (curr, next) {
      var coords = [next - 360, next, next + 360];
      var distances = coords.map(function (c) {
        return Math.abs(curr - c);
      });
      return coords[distances.indexOf(Math.min.apply(null, distances))];
    };

    return {
      lat: f(this.lat, lat),
      lon: f(this.lon, lon),
    };
  },

  setAbsolutePosition: function (position, options) {
    var lat = position.lat == undefined ? this.lat : position.lat,
      lon = position.lon == undefined ? this.lon : position.lon,
      fov = position.fov == undefined ? this.fov : position.fov;

    if (options.duration || options.speed) {
      var shortCoord = this.getShortestLatLon(lat, lon);

      if (!options.duration && options.speed) {
        var totalDegrees = Math.sqrt(
          Math.pow(this.lat - shortCoord.lat, 2) +
            Math.pow(this.lon - shortCoord.lon, 2)
        );

        options.duration = (totalDegrees / options.speed) * 1000;
      }

      // Force the view to refresh first to update the clock
      this.refreshView();
      this.isRotating = true;
      this.rotationObject.fromLon = this.lon;
      this.rotationObject.fromLat = this.lat;
      this.rotationObject.targetLat = shortCoord.lat;
      this.rotationObject.targetLon = shortCoord.lon;
      this.rotationObject.startTime = new Date().getTime();
      this.rotationObject.duration = options.duration;
      this.rotationObject.callback = options.callback;

      this.setAutoRotate(false);
    } else {
      this.lat = lat;
      this.lon = lon;
      this.fov = fov;
    }
    this.refreshView();
    this.refreshZoom();
  },

  setPositionExact: function (x, y) {
    if (
      this.isMouseMoving &&
      !this.processingMove &&
      !this.latDiff &&
      !this.lonDiff
    ) {
      this.processingMove = true;

      var point = this.getPointFromMouse(x, y),
        radius = this.viewerWidth * 4,
        spLat = Math.asin(this.startPoint.y / radius),
        pLat = Math.asin(point.y / radius),
        latDiff = ((spLat - pLat) * 180) / Math.PI,
        spLon = Math.atan(this.startPoint.z / this.startPoint.x),
        pLon = Math.atan(point.z / point.x),
        lonDiff;

      if (
        (point.x < 0 && this.startPoint.x > 0) ||
        (point.x > 0 && this.startPoint.x < 0)
      ) {
        if (pLon > 0 && spLon < 0) {
          lonDiff = Math.PI + spLon - pLon;
        } else if (pLon < 0 && spLon > 0) {
          lonDiff = Math.PI - spLon + pLon;
        } else {
          lonDiff = spLon - pLon;
        }

        //adjust for direction
        if (
          (point.x < 0 && this.lon < 180) ||
          (point.x > 0 && this.lon > 180)
        ) {
          lonDiff *= -1;
        }
      } else {
        lonDiff = spLon - pLon;
      }

      lonDiff *= 180 / Math.PI;

      this.latDiff += latDiff;
      this.lonDiff += lonDiff;

      this.processingMove = false;
    }
  },

  getPointFromMouse: function (x, y) {
    var rect = this.panorama.element.getBoundingClientRect();

    x = (x - rect.left) / rect.width;
    y = (y - rect.top) / rect.height;

    this.pointerVector.set(x * 2 - 1, -y * 2 + 1, 0.5);
    return this.getPointerVectorIntersect();
  },

  getPointerVectorIntersect: function () {
    this.pointerVector.unproject(this.getCamera());

    this.raycaster.set(
      this.getCamera().position,
      this.pointerVector.normalize()
    );

    var intersects = this.raycaster.intersectObject(
      this.panorama.intersectionMesh
    );

    return intersects.length ? intersects[0].point : null;
  },
};

//panorama types

/*                                                                                                                                                 
PPPPPPPPPPPPPPPPP                                                                                                                                   
P::::::::::::::::P                                                                                                                                  
P::::::PPPPPP:::::P                                                                                                                                 
PP:::::P     P:::::P                                                                                                                                
P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   rrrrr   rrrrrrrrr   aaaaaaaaaaaaa      mmmmmmm    mmmmmmm     aaaaaaaaaaaaa   
P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo r::::rrr:::::::::r  a::::::::::::a   mm:::::::m  m:::::::mm   a::::::::::::a  
P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::or:::::::::::::::::r aaaaaaaaa:::::a m::::::::::mm::::::::::m  aaaaaaaaa:::::a 
P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::orr::::::rrrrr::::::r         a::::a m::::::::::::::::::::::m           a::::a 
P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o r:::::r     r:::::r  aaaaaaa:::::a m:::::mmm::::::mmm:::::m    aaaaaaa:::::a 
P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o r:::::r     rrrrrrraa::::::::::::a m::::m   m::::m   m::::m  aa::::::::::::a 
P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o r:::::r           a::::aaaa::::::a m::::m   m::::m   m::::m a::::aaaa::::::a 
P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o r:::::r          a::::a    a:::::a m::::m   m::::m   m::::ma::::a    a:::::a 
PP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o r:::::r          a::::a    a:::::a m::::m   m::::m   m::::ma::::a    a:::::a 
P::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o r:::::r          a:::::aaaa::::::a m::::m   m::::m   m::::ma:::::aaaa::::::a 
P::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo  r:::::r           a::::::::::aa:::am::::m   m::::m   m::::m a::::::::::aa:::a
PPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo    rrrrrrr            aaaaaaaaaa  aaaammmmmm   mmmmmm   mmmmmm  aaaaaaaaaa  aaaa
*/
//baseclass
var Panorama = function (player) {
  this.player = player;

  this.rootType = null;

  this.meshes = [];
  this._ondrag = [];
  this._onDestroyCBs = [];

  this.animate = this.animate.bind(this);
  this.regenerateTextures = noop;

  // Used to determine click events
  this.dragInitiatedTime;
  this.dragEndedTime;
};

Panorama.getTileUrl = function (panoPath, type, size, coord) {
  var clazz = PanoPlayer.panoramas[type];

  if (type == PanoPlayer.types.WEBGL || type == PanoPlayer.types.CANVAS) {
    clazz = EquirectangularPanorama;
  }
  return clazz._getTileUrl(panoPath, size, coord);
};

Panorama.prototype = {
  setAutoRotate: function (onOff, autoRotateSpeed) {
    this.camera.setAutoRotate(onOff, autoRotateSpeed);
  },

  embed: function () {
    var _this = this;

    this.scene = new THREE.Scene();
    this.scene.frustumCulled = false;
    this.camera = new Camera(this.player.getCameraOptions(), this);

    this.createIntersectionMesh();

    this.addMeshesToScene();

    this.attachHandlers();

    this.needsRefresh = true;
    this.needsConstantRefresh = false;

    //start animation loop
    this.animate();
  },

  createIntersectionMesh: function () {
    this.intersectionMesh = new THREE.Mesh(
      new THREE.SphereGeometry(this.player.viewerWidth * 2), //check for legacy probs
      new THREE.MeshBasicMaterial({
        side: THREE.BackSide,
      })
    );
  },

  addMeshesToScene: function () {
    for (var i in this.meshes) {
      this.scene.add(this.meshes[i]);
    }
  },

  animate: function () {
    var _this = this;
    this.lastAnimationRequest = requestAnimationFrame(this.animate);

    if (this.camera.needsRefresh()) {
      this.camera.refreshView();
      this.needsRefresh = true;
    }

    if (this.needsRefresh || this.needsConstantRefresh) {
      this.renderer.autoClear = false;
      if (this.renderer.clear) this.renderer.clear();
      this.renderer.render(this.scene, this.camera.getCamera());
      this.scene.draw(delta);
      this.needsRefresh = false;
    }
  },
  /**
   * This function should be turned off as often as on
   * It will cause high CPU usage on devices but result in max frame rate
   */
  setConstantRefresh: function (enabled) {
    this.needsConstantRefresh = enabled;
  },

  setNeedsRefresh: function () {
    this.needsRefresh = true;
  },

  onDestroy: function (callback) {
    if (callback) {
      this._onDestroyCBs.push(callback);
    }
  },

  destroy: function () {
    for (var i = 0; i < this._onDestroyCBs.length; i++) {
      if (this._onDestroyCBs[i]) this._onDestroyCBs[i]();
    }

    if (this.lastAnimationRequest) {
      var cancelAnimationFrame =
        window.cancelAnimationFrame || window.mozCancelAnimationFrame;
      cancelAnimationFrame(this.lastAnimationRequest);
    }

    this.removeHandlers();
    this._onDestroyCBs = null;
    if (this.element) {
      CanvasManager.releaseCanvas(this.element);
      this.element = null;
    }

    this.camera.destroy();

    delete this.scene;
    delete this.camera;
  },

  setSize: function (width, height) {
    this.renderer.setSize(width, height);

    this.needsRefresh = true;

    if (this.camera) {
      this.camera.updateMatrix(width, height);
    }
  },

  getTileUrl: function (coord, zoom) {
    var clazz = PanoPlayer.panoramas[this.rootType],
      size =
        zoom !== undefined
          ? this.player.zoomLevels[zoom]
          : this.player.getPanoWidth();

    return clazz._getTileUrl(
      this.player.basePath + this.player.panoId + "/",
      size,
      coord
    );
  },

  /**
   * Adds a listener function for drag events
   * Also removes drag hint if applicable
   * @param  callback {Function} - function to listen to drag events
   */
  onDrag: function (callback) {
    this._ondrag.push(callback);
  },

  /**
   * @param  callback {Function} - function to stop listen to drag events
   * Removes a specified listener function for drag events or removeds
   * all listeners if no callback specified
   */
  offDrag: function (callback) {
    if (callback) {
      for (var i = 0; i < this._ondrag.length; i++) {
        if (this._ondrag[i] === callback) {
          this._ondrag.splice(i, 1);
          i--;
        }
      }
    } else {
      this._ondrag = [];
    }
  },

  /**
   * triggers all registered drag events
   */
  triggerDrag: function () {
    for (var i = 0; i < this._ondrag.length; i++) {
      this._ondrag[i]();
    }
  },

  events: {
    mousedown: null,
    mousemove: null,
    mouseup: document,
    wheel: null,
    mousewheel: null,
    touchstart: document,
    touchmove: document,
    touchend: document,
    mouseout: null,
    click: null,
  },

  handleEvent: function (event) {
    if (this.camera.isRotating) {
      return;
    }
    if (this.isOwnElement(event.target)) {
      // PREVENT EVENTS ON OTHER TARGETS
      if (event.defaultPrevented != false) event.preventDefault();
    } else {
      // PREVENT ALL CAMERA EVENTS IF NOT THE TARGET
      return;
    }

    if (event.type.indexOf("touch") != -1 && event.touches.length) {
      event.clientX = event.touches[0].clientX;
      event.clientY = event.touches[0].clientY;
    }

    this.player.eventEmitter.emit(event.type, [event]);

    switch (event.type) {
      case "mouseout":
        this.camera.setMouseMoving(false);
        this.scene.call("mouseout", []);
        break;
      case "mousedown":
      case "touchstart":
        this.setAutoRotate(false);
        this.player.enableAccelerometerControls(false);
        if (!this.camera.isDisabled()) {
          this.camera.setMouseMoving(true);
          this.camera.setStart(event.clientX, event.clientY);
        }
        this.scene.call("mousedown", []);

        this.dragStarted = false;
        // Used to determine if click event is called on mouseup
        this.dragInitiatedTime = new Date().getTime();
        break;

      case "touchmove":
      case "mousemove":
        if (event.defaultPrevented != false) event.preventDefault();

        this.isDragging = this.camera.isMoving || this.camera.isMouseMoving;
        if (this.camera.isMouseMoving) {
          if (!this.dragStarted) {
            this.dragStarted = true;
            this.player.eventEmitter.emit("dragstart", [event]);
          }
          this.triggerDrag();
          this.camera.setPosition(event.clientX, event.clientY);
        }

        if (!this.mouse) {
          this.mouse = new THREE.Vector2();
        }
        
        var el = typeof event.target == 'object' ? event.target : document.querySelector(event.target),
          x = event.pageX - el.getBoundingClientRect().left,
          y = event.pageY - el.getBoundingClientRect().top;
        this.mouse.x = (x / this.player.viewerWidth) * 2 - 1;
        this.mouse.y = -(y / this.player.viewerHeight) * 2 + 1;
        this.scene.call("mousemove", []);
        break;

      case "mouseup":
      case "touchend":
        this.camera.setMouseMoving(false);

        var hasDeviceControls = this.camera.hasDeviceControls();

        if (hasDeviceControls) this.camera.setResetOrientationDeltas(true);

        this.player.enableAccelerometerControls(true);

        // Used to determine if click event is called
        this.dragEndedTime = new Date().getTime();

        if (this.isDragging) {
          this.player.eventEmitter.emit("dragend", [event]);
        } else {
          //this even will allow us to have similar to click for mobile.
          //if ! dragging and we are ending then. call touch
          this.scene.call("touch", []);

          // Transmit click event to positional media so they can transmit play state based on UI
          // Because clicks can initiate slight drags even when the mouse is initially still, we can use the amount of drag time
          // to estimate whether the user intended to drag or if it was meant as a click
          if (this.dragEndedTime - this.dragInitiatedTime < 200) {
            var toClick = this.scene.getIntersection(
              "click",
              this.camera,
              this.mouse
            );
            toClick && toClick[0].call("click", toClick[1]);
            this.player.eventEmitter.emit("click", [event]);
          } else {
            // Update lastLon and lastLat to current lat and lon
            this.camera.lastLon = this.camera.lon;
            this.camera.lastLat = this.camera.lat;
          }
        }
        this.scene.call("mouseup", []);
        this.isDragging = false;
        break;

      case "wheel":
      case "mousewheel":
        this.player.eventEmitter.emit("mousewheel", [event]);
        !this.player.options.disableZoom &&
          this.camera.zoom(
            event.wheelDelta > 0 || event.detail < 0 || event.deltaY < 0
              ? 1
              : -1
          );
        break;
      case "click":
        this.isDragging = false;
        break;
    }
  },

  isOwnElement: function (element) {
    return element == this.element;
  },

  //event handlers
  attachHandlers: function () {
    for (var i in this.events) {
      var scope = this.events[i] || this.element;
      scope.addEventListener(i, this, false);
    }
  },

  removeHandlers: function () {
    for (var i in this.events) {
      var scope = this.events[i] || this.element;
      scope.removeEventListener(i, this, false);
    }
  },
};

/*                                                                
                                                                                                                                        
EEEEEEEEEEEEEEEEEEEEEE                                        iiii  PPPPPPPPPPPPPPPPP                                                     
E::::::::::::::::::::E                                       i::::i P::::::::::::::::P                                                    
E::::::::::::::::::::E                                        iiii  P::::::PPPPPP:::::P                                                   
EE::::::EEEEEEEEE::::E                                              PP:::::P     P:::::P                                                  
E:::::E       EEEEEE   qqqqqqqqq   qqqqquuuuuu    uuuuuu  iiiiiii   P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   
E:::::E               q:::::::::qqq::::qu::::u    u::::u  i:::::i   P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo 
E::::::EEEEEEEEEE    q:::::::::::::::::qu::::u    u::::u   i::::i   P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o
E:::::::::::::::E   q::::::qqqqq::::::qqu::::u    u::::u   i::::i   P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o
E:::::::::::::::E   q:::::q     q:::::q u::::u    u::::u   i::::i   P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o
E::::::EEEEEEEEEE   q:::::q     q:::::q u::::u    u::::u   i::::i   P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o
E:::::E             q:::::q     q:::::q u::::u    u::::u   i::::i   P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o
E:::::E       EEEEEEq::::::q    q:::::q u:::::uuuu:::::u   i::::i   P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o
EE::::::EEEEEEEE:::::Eq:::::::qqqqq:::::q u:::::::::::::::uui::::::iPP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o
E::::::::::::::::::::E q::::::::::::::::q  u:::::::::::::::ui::::::iP::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o
E::::::::::::::::::::E  qq::::::::::::::q   uu::::::::uu:::ui::::::iP::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo 
EEEEEEEEEEEEEEEEEEEEEE    qqqqqqqq::::::q     uuuuuuuu  uuuuiiiiiiiiPPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   
                                q:::::q                                                                                                 
                                q:::::q                                                                                                 
                               q:::::::q                                                                                                
                               q:::::::q                                                                                                
                               q:::::::q                                                                                                
                               qqqqqqqqq                                                                                                
*/
var EquiPanorama = function () {
  Panorama.apply(this, arguments);

  var scope = this,
    geo = new THREE.SphereGeometry(this.player.viewerWidth * 4, 32, 64),
    im = new Image(),
    texture = new THREE.Texture();

  im.crossOrigin = "anonymous";
  im.addEventListener(
    "load",
    function () {
      scope.camera.refreshView();
      /**
       * This is to fix a bug ith iOS Safari where the image displays incorrectly
       * Current leading theory as to what causes this is subsampling - see: http://stackoverflow.com/questions/12554947/mobile-safari-renders-img-src-dataimage-jpegbase64-scaled-on-canvas
       * but still not sure why this would fix it. Perhaps it's related to the browser rendering the image internally and caching it
       *
       * Also note that bug only appeard in protrait mode
       */
      document.createElement("canvas").getContext("2d").drawImage(im, 0, 0);

      texture.image = im;
      texture.needsUpdate = true;
      scope.player.requestUpdate();
    },
    false
  );

  im.src = this.player.options.localMode.data;

  var mat = new THREE.MeshBasicMaterial({
    map: texture,
    side: THREE.BackSide,
  });

  var mesh = new THREE.Mesh(geo, mat);

  mesh.scale.z = -1;

  this.meshes.push(mesh);

  if (this.player.options.localMode.correction) {
    var pitch =
      (Math.PI * this.player.options.localMode.correction.pitch) / 180;
    var roll = (Math.PI * this.player.options.localMode.correction.roll) / 180;

    mesh.rotation.set(roll, 0, pitch);
  }

  this.element = CanvasManager.getCanvas();
  this.renderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas: this.element,
  });
};

EquiPanorama.prototype = Object.create(Panorama.prototype);

/*                                                                                                                                                                                                                                                                                                                                               
EEEEEEEEEEEEEEEEEEEEEE                                        iiii                                                                      tttt                                                                                   lllllll                                    PPPPPPPPPPPPPPPPP                                                     
E::::::::::::::::::::E                                       i::::i                                                                  ttt:::t                                                                                   l:::::l                                    P::::::::::::::::P                                                    
E::::::::::::::::::::E                                        iiii                                                                   t:::::t                                                                                   l:::::l                                    P::::::PPPPPP:::::P                                                   
EE::::::EEEEEEEEE::::E                                                                                                               t:::::t                                                                                   l:::::l                                    PP:::::P     P:::::P                                                  
E:::::E       EEEEEE   qqqqqqqqq   qqqqquuuuuu    uuuuuu  iiiiiiirrrrr   rrrrrrrrr       eeeeeeeeeeee        ccccccccccccccccttttttt:::::ttttttt      aaaaaaaaaaaaa  nnnn  nnnnnnnn       ggggggggg   ggggguuuuuu    uuuuuu   l::::l   aaaaaaaaaaaaa  rrrrr   rrrrrrrrr   P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   
E:::::E               q:::::::::qqq::::qu::::u    u::::u  i:::::ir::::rrr:::::::::r    ee::::::::::::ee    cc:::::::::::::::ct:::::::::::::::::t      a::::::::::::a n:::nn::::::::nn    g:::::::::ggg::::gu::::u    u::::u   l::::l   a::::::::::::a r::::rrr:::::::::r  P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo 
E::::::EEEEEEEEEE    q:::::::::::::::::qu::::u    u::::u   i::::ir:::::::::::::::::r  e::::::eeeee:::::ee c:::::::::::::::::ct:::::::::::::::::t      aaaaaaaaa:::::an::::::::::::::nn  g:::::::::::::::::gu::::u    u::::u   l::::l   aaaaaaaaa:::::ar:::::::::::::::::r P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o
E:::::::::::::::E   q::::::qqqqq::::::qqu::::u    u::::u   i::::irr::::::rrrrr::::::re::::::e     e:::::ec:::::::cccccc:::::ctttttt:::::::tttttt               a::::ann:::::::::::::::ng::::::ggggg::::::ggu::::u    u::::u   l::::l            a::::arr::::::rrrrr::::::rP:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o
E:::::::::::::::E   q:::::q     q:::::q u::::u    u::::u   i::::i r:::::r     r:::::re:::::::eeeee::::::ec::::::c     ccccccc      t:::::t              aaaaaaa:::::a  n:::::nnnn:::::ng:::::g     g:::::g u::::u    u::::u   l::::l     aaaaaaa:::::a r:::::r     r:::::rP::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o
E::::::EEEEEEEEEE   q:::::q     q:::::q u::::u    u::::u   i::::i r:::::r     rrrrrrre:::::::::::::::::e c:::::c                   t:::::t            aa::::::::::::a  n::::n    n::::ng:::::g     g:::::g u::::u    u::::u   l::::l   aa::::::::::::a r:::::r     rrrrrrrP::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o
E:::::E             q:::::q     q:::::q u::::u    u::::u   i::::i r:::::r            e::::::eeeeeeeeeee  c:::::c                   t:::::t           a::::aaaa::::::a  n::::n    n::::ng:::::g     g:::::g u::::u    u::::u   l::::l  a::::aaaa::::::a r:::::r            P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o
E:::::E       EEEEEEq::::::q    q:::::q u:::::uuuu:::::u   i::::i r:::::r            e:::::::e           c::::::c     ccccccc      t:::::t    tttttta::::a    a:::::a  n::::n    n::::ng::::::g    g:::::g u:::::uuuu:::::u   l::::l a::::a    a:::::a r:::::r            P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o
EE::::::EEEEEEEE:::::Eq:::::::qqqqq:::::q u:::::::::::::::uui::::::ir:::::r            e::::::::e          c:::::::cccccc:::::c      t::::::tttt:::::ta::::a    a:::::a  n::::n    n::::ng:::::::ggggg:::::g u:::::::::::::::uul::::::la::::a    a:::::a r:::::r          PP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o
E::::::::::::::::::::E q::::::::::::::::q  u:::::::::::::::ui::::::ir:::::r             e::::::::eeeeeeee   c:::::::::::::::::c      tt::::::::::::::ta:::::aaaa::::::a  n::::n    n::::n g::::::::::::::::g  u:::::::::::::::ul::::::la:::::aaaa::::::a r:::::r          P::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o
E::::::::::::::::::::E  qq::::::::::::::q   uu::::::::uu:::ui::::::ir:::::r              ee:::::::::::::e    cc:::::::::::::::c        tt:::::::::::tt a::::::::::aa:::a n::::n    n::::n  gg::::::::::::::g   uu::::::::uu:::ul::::::l a::::::::::aa:::ar:::::r          P::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo 
EEEEEEEEEEEEEEEEEEEEEE    qqqqqqqq::::::q     uuuuuuuu  uuuuiiiiiiiirrrrrrr                eeeeeeeeeeeeee      cccccccccccccccc          ttttttttttt    aaaaaaaaaa  aaaa nnnnnn    nnnnnn    gggggggg::::::g     uuuuuuuu  uuuullllllll  aaaaaaaaaa  aaaarrrrrrr          PPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   
                                q:::::q                                                                                                                                                            g:::::g                                                                                                                                    
                                q:::::q                                                                                                                                                gggggg      g:::::g                                                                                                                                    
                               q:::::::q                                                                                                                                               g:::::gg   gg:::::g                                                                                                                                    
                               q:::::::q                                                                                                                                                g::::::ggg:::::::g                                                                                                                                    
                               q:::::::q                                                                                                                                                 gg:::::::::::::g                                                                                                                                     
                               qqqqqqqqq                                                                                                                                                       gggggg                                                                                                                                                                                                                                     
*/
var EquirectangularPanorama = function () {
  Panorama.apply(this, arguments);

  this.rootType = PanoPlayer.types.EQUIRECTANGULAR;

  this.panoPlayer = arguments[0];

  this.element = CanvasManager.getCanvas();
  this.renderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas: this.element,
  });

  this.imageLoaded = false;
  this.loadedImage = this.loadedImage.bind(this);

  this.createEquiMesh();

  this.createBusinessCard(this.player.options.businessCard);
};

EquirectangularPanorama.prototype = Object.create(Panorama.prototype);

EquirectangularPanorama.allowedZooms = [2, 3, 4, 5];

EquirectangularPanorama.prototype.createEquiMesh = function () {
  var texture = this.player.options.texture;
  if (!texture) {
    texture = new THREE.TextureLoader().load(this.getTileUrl(), function () {
      _this.loadedImage();
      _this.needsRefresh = true;
    });
  } else {
    fireEvent("viewReady", this.player);
  }

  var _this = this,
    hqSphere = new THREE.Mesh(
      new THREE.SphereGeometry(this.player.viewerWidth * 4, 64, 32),
      new THREE.MeshBasicMaterial({
        map: texture,
        side: THREE.BackSide,
      })
    );
  hqSphere.scale.x = -1;

  this.hqSphereIndex = this.meshes.length;
  this.meshes.push(hqSphere);
};

EquirectangularPanorama.prototype.createBusinessCard = function (text) {
  if (!text) {
    return;
  }

  var width = 420,
    height = 170,
    canvas = document.createElement("canvas"),
    context = canvas.getContext("2d"),
    cTexture = new THREE.Texture(canvas),
    card = new THREE.Mesh(
      new THREE.PlaneGeometry(width, height),
      new THREE.MeshBasicMaterial({
        map: cTexture,
        color: 0xffffffff,
      })
    ),
    fontSize = 20;

  canvas.width = width;
  canvas.height = height;

  context.fillStyle = "rgba(255,255,255,0.7)";
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.font = fontSize + "px Arial";
  context.fillStyle = "rgb(0,0,0)";
  context.textAlign = "center";

  text = text.split("\n");

  var margin = (height - fontSize * text.length) / (text.length + 1),
    hIndex = margin + 45; //not 100% why this is necessary but otherwise its too near the top

  for (var i in text) {
    context.fillText(text[i], width / 2, hIndex);
    hIndex += fontSize + margin;
  }

  cTexture.needsUpdate = true;

  card.rotation.x = -Math.PI / 2;
  card.position.setY(-500);

  this.meshes.push(card);
};

// we only need to load one image, so let's just do that
EquirectangularPanorama.prototype.loadedImage = function () {
  this.needsRefresh = true;

  if (!this.player.viewReadyFired) {
    fireEvent("viewReady", this.player);
  }
  fireEvent("panoLoaded", this.player);
};

EquirectangularPanorama.prototype.regenerateTextures = function () {
  var _this = this;

  for (var mI in this.meshes) {
    this.meshes[mI].visible = false;
  }

  this.createEquiMesh();
};

EquirectangularPanorama.prototype.destroy = function () {
  Panorama.prototype.destroy.call(this);

  // we need to free texture image resources to prevent memory leaking
  for (var i = 0; i < this.meshes.length; i++) {
    var mesh = this.meshes[i];

    // if the material is a basic material, it will only have one material to clean up
    if (mesh.material.type == "MeshBasicMaterial") {
      mesh.material.map.dispose();

      // otherwise, clean em all up
    } else {
      for (var m = 0; m < mesh.material.length; m++) {
        var mat = mesh.material[m];

        //this.renderer.deallocateTexture(mat.map);
        mat.map.dispose();
      } //next m
    } //endif
  } //next i
};

EquirectangularPanorama._getTileUrl = function (path, size, coord) {
  return originCacheBuster(path + size + ".jpg");
};

/*
                                                        bbbbbbbb                                                                                                             
WWWWWWWW                           WWWWWWWW               b::::::b                               lllllll PPPPPPPPPPPPPPPPP                                                     
W::::::W                           W::::::W               b::::::b                               l:::::l P::::::::::::::::P                                                    
W::::::W                           W::::::W               b::::::b                               l:::::l P::::::PPPPPP:::::P                                                   
W::::::W                           W::::::W                b:::::b                               l:::::l PP:::::P     P:::::P                                                  
W:::::W           WWWWW           W:::::W eeeeeeeeeeee    b:::::bbbbbbbbb       ggggggggg   gggggl::::l   P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   
W:::::W         W:::::W         W:::::Wee::::::::::::ee  b::::::::::::::bb    g:::::::::ggg::::gl::::l   P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo 
 W:::::W       W:::::::W       W:::::We::::::eeeee:::::eeb::::::::::::::::b  g:::::::::::::::::gl::::l   P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o
  W:::::W     W:::::::::W     W:::::We::::::e     e:::::eb:::::bbbbb:::::::bg::::::ggggg::::::ggl::::l   P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o
   W:::::W   W:::::W:::::W   W:::::W e:::::::eeeee::::::eb:::::b    b::::::bg:::::g     g:::::g l::::l   P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o
    W:::::W W:::::W W:::::W W:::::W  e:::::::::::::::::e b:::::b     b:::::bg:::::g     g:::::g l::::l   P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o
     W:::::W:::::W   W:::::W:::::W   e::::::eeeeeeeeeee  b:::::b     b:::::bg:::::g     g:::::g l::::l   P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o
      W:::::::::W     W:::::::::W    e:::::::e           b:::::b     b:::::bg::::::g    g:::::g l::::l   P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o
       W:::::::W       W:::::::W     e::::::::e          b:::::bbbbbb::::::bg:::::::ggggg:::::gl::::::lPP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o
        W:::::W         W:::::W       e::::::::eeeeeeee  b::::::::::::::::b  g::::::::::::::::gl::::::lP::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o
         W:::W           W:::W         ee:::::::::::::e  b:::::::::::::::b    gg::::::::::::::gl::::::lP::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo 
          WWW             WWW            eeeeeeeeeeeeee  bbbbbbbbbbbbbbbb       gggggggg::::::gllllllllPPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   
                                                                                        g:::::g                                                                              
                                                                            gggggg      g:::::g                                                                              
                                                                            g:::::gg   gg:::::g                                                                              
                                                                             g::::::ggg:::::::g                                                                              
                                                                              gg:::::::::::::g                                                                               
                                                                                ggg::::::ggg                                                                                 
                                                                                   gggggg                                                                                    
*/
function WebglPanorama() {
  EquirectangularPanorama.apply(this, arguments);

  this.element = CanvasManager.getCanvas();
  this.renderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas: this.element,
  });

  return this;
}

WebglPanorama.prototype = Object.create(EquirectangularPanorama.prototype);

WebglPanorama.allowedZooms = [0, 2, 3, 4, 5];

function EasyPanorama() {
  Panorama.apply(this, arguments);

  this.rootType = PanoPlayer.types.EASY;

  this.geometry = new THREE.SphereGeometry(
    this.player.viewerWidth * 4,
    128,
    64
  );

  this.texture = this.player.options.texture || new THREE.Texture();
  this.texture.minFilter = THREE.LinearFilter;

  var shader = this.player.options.shader || this.generateShader();

  this.material = new THREE.ShaderMaterial({
    uniforms: {
      texture: { type: "t", value: this.texture },
    },
    vertexShader: shader.vertex,
    fragmentShader: shader.fragment,
    side: THREE.BackSide,
  });

  this.lowQuality = 512;

  if (this.player.zoom > 1) {
    this.lqIndex = 0;
    this.createEasyMesh(this.lowQuality);
  }

  this.imageLoaded = false;
  this.loadedImage = this.loadedImage.bind(this);

  this.createEasyMesh(null, this.loadedImage);

  this.element = CanvasManager.getCanvas();
  this.renderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas: this.element,
  });

  return this;
}

EasyPanorama.prototype = Object.create(Panorama.prototype);

EasyPanorama.prototype.createEasyMesh = function (size, cb) {
  this.shape = PanoPlayer.types.EASY;

  var scope = this,
    imgSrc = this.getTileUrl(null, size == this.lowQuality ? 0 : undefined),
    image = new Image(),
    mesh;

  image.crossOrigin = "anonymous";
  if (this.player.options.path) {
    image.onload = function () {
      if (typeof cb == "function") cb();

      // If highres image loaded no need to update texture to lowres
      if (scope.imageLoaded && size == scope.lowQuality) return;

      requestAnimationFrame(function () {
        scope.texture.image = image;
        scope.texture.needsUpdate = true;
        scope.player.requestUpdate();
      });

      if (!scope.player.viewReadyFired) {
        fireEvent("viewReady", scope.player);
      }
      if (size !== scope.lowQuality) {
        fireEvent("panoLoaded", scope.player);
      }
    };
    image.src = imgSrc;
  }

  mesh = new THREE.Mesh(this.geometry, this.material);
  mesh.scale.x = -1;
  this.meshes.push(mesh);
};

EasyPanorama.prototype.loadedImage = function () {
  this.imageLoaded = true;

  if (
    typeof this.lqIndex != "undefined" &&
    this.lqIndex in this.meshes &&
    !this.destroying
  ) {
    this.scene.remove(this.meshes[this.lqIndex]);

    var mesh = this.meshes.splice(this.lqSphereIndex, 1)[0];

    mesh.material.dispose();
    mesh.geometry.dispose();
  }
};

EasyPanorama.prototype.generateShader = function () {
  //Easy cap parameters. Hardcoded for now, but turn in to PHP lookup eventually?
  //the following parameters were generated by: ffmpeg -i input.jpg -vf equitoeasy=print_params=1 output.jpg
  ///////////////////////////
  var alim0 = 3.141592653589793116,
    alim1 = -3.141592653589793116, //limits of the horizontal equirectangular axis (=azimuth angle)
    blim0 = 1.570796326794896558,
    blim1 = -1.570796326794896558, //limits of the vertical equirectangular axis (=elevation angle)
    ulim0 = 3.1415927410125732422,
    ulim1 = -3.1415927410125732422, //limits of horizontal EASY axis
    vlim0 = 1,
    vlim1 = -1; //limits of the vertical EASY axis

  //these parameters must match the ffmpeg encoding parameters!
  var BLOCKSIZE = 16,
    POLE_OVERLAP_PIX = 1, //the OVERLAP_PIX params are all buffers to avoid bleeding across EASY sections
    RING_OVERLAP_PIX_AZ = 1,
    RING_OVERLAP_PIX_EL = 1,
    PROJ_OVERLAP_PIX_AZ = 1, //had to include despite wraparound due to VR Unity shader behavior
    PROJ_OVERLAP_PIX_EL = 1,
    NV_MIN = 160,
    NU_MIN = 512;
  // MIN_NP = NV_MIN*NU_MIN;//size of the smallest size (k=1)

  var R = 4, //number of EASY rings, including polar cap
    n = [1, 6, 10, 15], //number of tiles per ring
    phi = [
      1.4589346132593310479,
      1.2739031247656165124,
      1.1056367510067890425,
      0.92729520797729492188,
    ]; //elevations of bottom edges of rings
  ///////////////////////////

  //calculable EASY params
  var ring_ulim0 = [],
    ring_ulim1 = [],
    ring_vlim0,
    ring_vlim1,
    proj_a2u_m,
    proj_a2u_b,
    proj_b2v_m,
    proj_b2v_b,
    cumsum_n = [],
    N,
    cap_thresh_left,
    cap_thresh_top,
    polar_radius;

  //v limits of the top ring section, not including overlap
  ring_vlim0 = RING_OVERLAP_PIX_EL;
  ring_vlim1 = BLOCKSIZE - RING_OVERLAP_PIX_EL;

  //precalculate slope and offset for linear interpolations for central projection so that pixel overlaps are handled properly
  proj_a2u_m = (1.0 - (2.0 * PROJ_OVERLAP_PIX_AZ) / NU_MIN) / (ulim1 - ulim0);
  proj_a2u_b = -ulim0 * proj_a2u_m + PROJ_OVERLAP_PIX_AZ / NU_MIN;

  var CC = PROJ_OVERLAP_PIX_EL / (NV_MIN / 2.0 - BLOCKSIZE);
  proj_b2v_m = (1.0 - CC) / (vlim1 - vlim0);
  proj_b2v_b =
    -vlim0 * proj_b2v_m + (BLOCKSIZE * CC + PROJ_OVERLAP_PIX_EL) / NV_MIN;

  cumsum_n[0] = n[0];
  for (var ii = 1; ii < R; ++ii) {
    cumsum_n[ii] = cumsum_n[ii - 1] + n[ii];
    ring_ulim0[ii - 1] = cumsum_n[ii - 1] * BLOCKSIZE + RING_OVERLAP_PIX_AZ;
    ring_ulim1[ii - 1] = cumsum_n[ii] * BLOCKSIZE - RING_OVERLAP_PIX_AZ;
  }
  N = cumsum_n[R - 1];

  cap_thresh_left = lerp(0.0, NU_MIN, ulim0, ulim1, BLOCKSIZE);
  cap_thresh_top = Math.sin(phi[R - 1]);
  polar_radius =
    blim0 -
    phi[0] +
    lerp(0.0, BLOCKSIZE, 0.0, 2.0 * (blim0 - phi[0]), POLE_OVERLAP_PIX);
  //end Easy cap parameters

  function buildRings() {
    var rings = "";
    for (var ii = 1; ii < R; ++ii) {
      rings +=
        (ii == 1 ? "if" : "else if") +
        "((abs(b)<=" +
        phi[ii - 1].toFixed(20) +
        ") && (abs(b)>" +
        phi[ii].toFixed(20) +
        ")){" +
        "u = lerp(" +
        alim0.toFixed(20) +
        "," +
        alim1.toFixed(20) +
        "," +
        ring_ulim0[ii - 1].toFixed(20) +
        "," +
        ring_ulim1[ii - 1].toFixed(20) +
        ", a);" +
        "u = lerp(0.0," +
        NU_MIN.toFixed(20) +
        "," +
        ulim0.toFixed(20) +
        "," +
        ulim1.toFixed(20) +
        ", u);" +
        "v = lerp(" +
        phi[ii - 1].toFixed(20) +
        "," +
        phi[ii].toFixed(20) +
        "," +
        ring_vlim0.toFixed(20) +
        "," +
        ring_vlim1.toFixed(20) +
        ", abs(b));" +
        "v = lerp(0.0," +
        NV_MIN.toFixed(20) +
        "," +
        vlim0.toFixed(20) +
        "," +
        vlim1.toFixed(20) +
        ", v);" +
        "}";
    }

    return rings + "else{" + "u = 0.0;" + "v = 0.0;" + "} ";
  }

  function lerp(alim0, alim1, ulim0, ulim1, a) {
    var u = ((a - alim0) / (alim1 - alim0)) * (ulim1 - ulim0) + ulim0;

    return u;
  }

  var fragmentShaderTxt =
    "uniform sampler2D texture;" +
    "varying vec2 vUv;" +
    "float uv2a(in float u, in float v)" +
    "{" +
    "return sqrt(u*u + v*v)*min(abs(1.0/cos(atan(v,u))),abs(1.0/cos(abs(" +
    Math.PI.toFixed(20) +
    "/2.0 - atan(v,u)))))*cos(atan(v,u));" +
    "}" +
    "float uv2b(in float u, in float v)" +
    "{" +
    "return sqrt(u*u + v*v)*min(abs(1.0/cos(atan(v,u))),abs(1.0/cos(abs(" +
    Math.PI.toFixed(20) +
    "/2.0 - atan(v,u)))))*sin(atan(v,u));" +
    "}" +
    "float lerp(in float alim0, in float alim1, in float ulim0, in float ulim1, in float a)" +
    "{" +
    "return ((a - alim0)/(alim1 - alim0)*(ulim1 - ulim0) + ulim0);" +
    "}" +
    "vec2 azel2caps_ffmpeg(vec2 UV){" +
    "float a;" +
    "float b;" +
    "float u;" +
    "float v;" +
    "float az_cap;" +
    "float el_cap;" +
    "float ringSign;" +
    "a = lerp(0.0,1.0," +
    alim0.toFixed(20) +
    "," +
    alim1.toFixed(20) +
    ",UV.x);" +
    "b = lerp(0.0,1.0," +
    blim0.toFixed(20) +
    "," +
    blim1.toFixed(20) +
    ",UV.y);" +
    "if(abs(b)<=asin(" +
    cap_thresh_top +
    ")){" +
    "u = a*" +
    proj_a2u_m.toFixed(20) +
    " + " +
    proj_a2u_b.toFixed(20) +
    ";" +
    "v = sin(b)*" +
    proj_b2v_m.toFixed(20) +
    " + " +
    proj_b2v_b.toFixed(20) +
    ";" +
    "}else{" +
    "ringSign = 1.0 - 2.0*float(b<0.0);" +
    "if(abs(b)>=" +
    phi[0].toFixed(20) +
    "){" +
    //polar cap
    "az_cap = atan(sin(a),ringSign*tan(b))/" +
    polar_radius.toFixed(20) +
    ";" +
    "el_cap = -asin(-ringSign*cos(a)*cos(b))/" +
    polar_radius.toFixed(20) +
    ";" +
    "u = lerp(-1.0,1.0," +
    ulim0.toFixed(20) +
    "," +
    cap_thresh_left.toFixed(20) +
    ",uv2a(az_cap,el_cap));" +
    "v = lerp(-1.0,1.0," +
    vlim0.toFixed(20) +
    "," +
    cap_thresh_top.toFixed(20) +
    ",ringSign*uv2b(az_cap,el_cap));" +
    "}else{ " +
    // 	//rings in cap
    buildRings() +
    "}" +
    "u = (u - (" +
    ulim0.toFixed(20) +
    "))/((" +
    ulim1.toFixed(20) +
    ") - (" +
    ulim0.toFixed(20) +
    "));" +
    "v = (ringSign*v - (" +
    vlim0.toFixed(20) +
    "))/((" +
    vlim1.toFixed(20) +
    ") - (" +
    vlim0.toFixed(20) +
    "));" +
    "}" +
    "return vec2(u,v);" +
    "}" +
    "void main() {" +
    "	gl_FragColor = texture2D(texture, azel2caps_ffmpeg(vUv));" +
    "}";

  var vertexShader =
    "attribute vec2 a_position;" +
    "varying vec2 vUv;" +
    "void main() {" +
    "	vUv = uv;" +
    "	gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);" +
    "}";

  return {
    fragment: fragmentShaderTxt,
    vertex: vertexShader,
  };
};

EasyPanorama.prototype.destroy = function () {
  this.destroying = true;
  Panorama.prototype.destroy.call(this);

  this.texture && this.texture.dispose();
  this.geometry && this.geometry.dispose();
  this.material && this.material.dispose();

  for (var index in this.meshes) {
    var mesh = this.meshes[index];

    mesh.geometry.dispose();
    mesh.material.dispose();
  }
};
EasyPanorama.allowedZooms = [0, 2, 3, 4, 5];

EasyPanorama._getTileUrl = function (path, size, coord) {
  return originCacheBuster(path + "easy/" + size + ".jpg");
};
/*                                                                                                                                                                     
      CCCCCCCCCCCCC                                                                                         PPPPPPPPPPPPPPPPP                                                     
   CCC::::::::::::C                                                                                         P::::::::::::::::P                                                    
 CC:::::::::::::::C                                                                                         P::::::PPPPPP:::::P                                                   
C:::::CCCCCCCC::::C                                                                                         PP:::::P     P:::::P                                                  
C:::::C       CCCCCC  aaaaaaaaaaaaa  nnnn  nnnnnnnn vvvvvvv           vvvvvvvaaaaaaaaaaaaa      ssssssssss     P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   
C:::::C                a::::::::::::a n:::nn::::::::nnv:::::v         v:::::v a::::::::::::a   ss::::::::::s    P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo 
C:::::C                aaaaaaaaa:::::an::::::::::::::nnv:::::v       v:::::v  aaaaaaaaa:::::ass:::::::::::::s   P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o
C:::::C                         a::::ann:::::::::::::::nv:::::v     v:::::v            a::::as::::::ssss:::::s  P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o
C:::::C                  aaaaaaa:::::a  n:::::nnnn:::::n v:::::v   v:::::v      aaaaaaa:::::a s:::::s  ssssss   P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o
C:::::C                aa::::::::::::a  n::::n    n::::n  v:::::v v:::::v     aa::::::::::::a   s::::::s        P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o
C:::::C               a::::aaaa::::::a  n::::n    n::::n   v:::::v:::::v     a::::aaaa::::::a      s::::::s     P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o
C:::::C       CCCCCCa::::a    a:::::a  n::::n    n::::n    v:::::::::v     a::::a    a:::::assssss   s:::::s   P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o
C:::::CCCCCCCC::::Ca::::a    a:::::a  n::::n    n::::n     v:::::::v      a::::a    a:::::as:::::ssss::::::sPP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o
 CC:::::::::::::::Ca:::::aaaa::::::a  n::::n    n::::n      v:::::v       a:::::aaaa::::::as::::::::::::::s P::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o
   CCC::::::::::::C a::::::::::aa:::a n::::n    n::::n       v:::v         a::::::::::aa:::as:::::::::::ss  P::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo 
      CCCCCCCCCCCCC  aaaaaaaaaa  aaaa nnnnnn    nnnnnn        vvv           aaaaaaaaaa  aaaa sssssssssss    PPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   
*/
function CanvasPanorama() {
  EquiPanorama.apply(this, arguments);

  this.element = CanvasManager.getCanvas();
  this.renderer = new THREE.CanvasRenderer({ canvas: this.element });

  return this;
}

CanvasPanorama.prototype = Object.create(EquiPanorama.prototype);

CanvasPanorama.allowedZooms = [0, 2, 3, 4, 5];

/*                                                                              dddddddd                                                                      
      CCCCCCCCCCCCC                                   333333333333333               d::::::dPPPPPPPPPPPPPPPPP                                                     
   CCC::::::::::::C                                  3:::::::::::::::33             d::::::dP::::::::::::::::P                                                    
 CC:::::::::::::::C                                  3::::::33333::::::3            d::::::dP::::::PPPPPP:::::P                                                   
C:::::CCCCCCCC::::C                                  3333333     3:::::3            d:::::d PP:::::P     P:::::P                                                  
C:::::C       CCCCCC    ssssssssss       ssssssssss               3:::::3    ddddddddd:::::d   P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   
C:::::C                ss::::::::::s    ss::::::::::s              3:::::3  dd::::::::::::::d   P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo 
C:::::C              ss:::::::::::::s ss:::::::::::::s     33333333:::::3  d::::::::::::::::d   P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o
C:::::C              s::::::ssss:::::ss::::::ssss:::::s    3:::::::::::3  d:::::::ddddd:::::d   P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o
C:::::C               s:::::s  ssssss  s:::::s  ssssss     33333333:::::3 d::::::d    d:::::d   P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o
C:::::C                 s::::::s         s::::::s                  3:::::3d:::::d     d:::::d   P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o
C:::::C                    s::::::s         s::::::s               3:::::3d:::::d     d:::::d   P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o
C:::::C       CCCCCCssssss   s:::::s ssssss   s:::::s             3:::::3d:::::d     d:::::d   P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o
C:::::CCCCCCCC::::Cs:::::ssss::::::ss:::::ssss::::::s3333333     3:::::3d::::::ddddd::::::ddPP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o
 CC:::::::::::::::Cs::::::::::::::s s::::::::::::::s 3::::::33333::::::3 d:::::::::::::::::dP::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o
   CCC::::::::::::C s:::::::::::ss   s:::::::::::ss  3:::::::::::::::33   d:::::::::ddd::::dP::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo 
      CCCCCCCCCCCCC  sssssssssss      sssssssssss     333333333333333      ddddddddd   dddddPPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   
*/

function Css3dPanorama() {
  Panorama.apply(this, arguments);

  this.rootType = PanoPlayer.types.CSS3D;
  this.tileSidePixels = this.player.viewerWidth * 4;
  this.sides = [
    {
      faceIndex: 1, //left
      position: [-this.tileSidePixels, 0, 0],
      rotation: [0, Math.PI / 2, 0],
    },
    {
      faceIndex: 0, //back
      position: [this.tileSidePixels, 0, 0],
      rotation: [0, -Math.PI / 2, 0],
    },
    {
      faceIndex: 2, //top
      position: [0, this.tileSidePixels, 0],
      rotation: [Math.PI / 2, 0, 0],
    },
    {
      faceIndex: 3, //bottom
      position: [0, -this.tileSidePixels, 0],
      rotation: [-Math.PI / 2, 0, 0],
    },
    {
      faceIndex: 5, //right
      position: [0, 0, this.tileSidePixels],
      rotation: [0, Math.PI, 0],
    },
    {
      faceIndex: 4, //front
      position: [0, 0, -this.tileSidePixels],
      rotation: [0, 0, 0],
    },
  ];

  var _this = this;

  this.player.setLoading(true);

  _this.init.apply(_this);

  return this;
}

Css3dPanorama.prototype = Object.create(Panorama.prototype);

Css3dPanorama.allowedZooms = [0, 2, 3, 4, 5];

Css3dPanorama.prototype.init = function () {
  for (var i = 0; i < this.sides.length; i++) {
    var side = this.sides[i];

    var element = document.createElement("img");
    element.width = this.tileSidePixels * 2 + 1; // 2 pixels extra to close the gap.
    element.crossOrigin = "anonymous";
    element.src = this.getTileUrl(side.faceIndex);

    var object = new CSS3DObject(element);
    object.position.fromArray(side.position);
    object.rotation.fromArray(side.rotation);
    this.meshes.push(object);
  }

  this.renderer = new CSS3DRenderer();
  this.element = this.renderer.domElement;

  this.player.setLoading(false);

  fireEvent("viewReady", this.player);
  fireEvent("panoLoaded", this.player);
};

Css3dPanorama.prototype.regenerateTextures = function () {
  for (var mindex in this.meshes) {
    this.meshes[mindex].element.style.display = "none";
  }
  for (var mI in this.meshes) {
    this.meshes[mI].element.src = this.getTileUrl(
      /_([0-9])\.jpg/.exec(this.meshes[mI].element.src)[1]
    );
    this.meshes[mI].element.style.display = "block";
  }
};

Css3dPanorama.prototype.isOwnElement = function (element) {
  for (var i in this.meshes) {
    if (this.meshes[i].element == element) {
      return true;
    }
  }

  return element == this.element || element == this.player.elem;
};

Css3dPanorama._getTileUrl = function (path, size, coord) {
  return EquiPanorama._getTileUrl(path, size, coord);
};

/*                                                                                                                                        
      CCCCCCCCCCCCC                                                         MMMMMMMM               MMMMMMMM                                        
   CCC::::::::::::C                                                         M:::::::M             M:::::::M                                        
 CC:::::::::::::::C                                                         M::::::::M           M::::::::M                                        
C:::::CCCCCCCC::::C                                                         M:::::::::M         M:::::::::M                                        
C:::::C       CCCCCC  aaaaaaaaaaaaa  nnnn  nnnnnnnn vvvvvvv           vvvvvvvM::::::::::M       M::::::::::M   ggggggggg   gggggrrrrr   rrrrrrrrr   
C:::::C                a::::::::::::a n:::nn::::::::nnv:::::v         v:::::v M:::::::::::M     M:::::::::::M  g:::::::::ggg::::gr::::rrr:::::::::r  
C:::::C                aaaaaaaaa:::::an::::::::::::::nnv:::::v       v:::::v  M:::::::M::::M   M::::M:::::::M g:::::::::::::::::gr:::::::::::::::::r 
C:::::C                         a::::ann:::::::::::::::nv:::::v     v:::::v   M::::::M M::::M M::::M M::::::Mg::::::ggggg::::::ggrr::::::rrrrr::::::r
C:::::C                  aaaaaaa:::::a  n:::::nnnn:::::n v:::::v   v:::::v    M::::::M  M::::M::::M  M::::::Mg:::::g     g:::::g  r:::::r     r:::::r
C:::::C                aa::::::::::::a  n::::n    n::::n  v:::::v v:::::v     M::::::M   M:::::::M   M::::::Mg:::::g     g:::::g  r:::::r     rrrrrrr
C:::::C               a::::aaaa::::::a  n::::n    n::::n   v:::::v:::::v      M::::::M    M:::::M    M::::::Mg:::::g     g:::::g  r:::::r            
C:::::C       CCCCCCa::::a    a:::::a  n::::n    n::::n    v:::::::::v       M::::::M     MMMMM     M::::::Mg::::::g    g:::::g  r:::::r            
C:::::CCCCCCCC::::Ca::::a    a:::::a  n::::n    n::::n     v:::::::v        M::::::M               M::::::Mg:::::::ggggg:::::g  r:::::r            
 CC:::::::::::::::Ca:::::aaaa::::::a  n::::n    n::::n      v:::::v         M::::::M               M::::::M g::::::::::::::::g  r:::::r            
   CCC::::::::::::C a::::::::::aa:::a n::::n    n::::n       v:::v          M::::::M               M::::::M  gg::::::::::::::g  r:::::r            
      CCCCCCCCCCCCC  aaaaaaaaaa  aaaa nnnnnn    nnnnnn        vvv           MMMMMMMM               MMMMMMMM    gggggggg::::::g  rrrrrrr            
                                                                                                                       g:::::g                     
                                                                                                           gggggg      g:::::g                     
                                                                                                           g:::::gg   gg:::::g                     
                                                                                                            g::::::ggg:::::::g                     
                                                                                                             gg:::::::::::::g                      
                                                                                                               ggg::::::ggg                        
                                                                                                                  gggggg                           
*/
var CanvasManager = {
  getCanvas: function () {
    return document.createElement("canvas");
  },
  releaseCanvas: function (canvas) {
    canvas.style.display = "none";
    try {
      canvas.parentNode.removeChild(canvas);
    } catch (e) {
      console.error(e.getMessage());
    }
  },
};

PanoPlayer.panoramas = {
  equi: EquiPanorama,
  webgl: WebglPanorama,
  easy: EasyPanorama,
  canvas: CanvasPanorama,
  css3d: Css3dPanorama,
  pano: Panorama,
  equirectangular: EquirectangularPanorama,
};

export default PanoPlayer;
